import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step9 } from '../../../../shared/models/component-messages/mapaIN/step9';
import { CriterePondere } from '../models/CriterePondere';

@Component({
  selector: 'app-critere-pondere',
  templateUrl: './critere-pondere.component.html'
})
export class CriterePondereComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'CriterePondere';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
  @Input() iteration: number;
	
	@Input() criterePondere: CriterePondere;

  public step9 = new Step9();

  constructor() { }

  public ngOnInit() {}

  
  public ngOnDestroy(): void {}
  
  
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
  
}

